import { InjectionToken } from "@angular/core";

export type EvoxConfig = {
  url: string;
  fallbackImage: string;
};

export const EVOX_CONFIG_TOKEN = new InjectionToken<EvoxConfig>("EVOX_CONFIG");
